<mat-form-field [hideRequiredMarker]="true" appearance="outline" class="full-width">
  <mat-label>{{label}}</mat-label>

  <input validatorColor matInput [matDatepicker]="picker" [formControl]="tempFormControl" >
 
  <mat-datepicker #picker ></mat-datepicker>

  <div matSuffix>
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <div style="position: relative; left:-2.5rem ;top: -2rem;">
      <ng-container *ngIf="tempFormControl.value && !tempFormControl.dirty">
        <mat-icon (click)="clearDate()" class="delete-icon">clear</mat-icon>
      </ng-container>
      <ng-container *ngIf="tempFormControl.dirty">
        <mat-icon (click)="resetField()" class="delete-icon">autorenew</mat-icon>
      </ng-container>
    </div>
  </div>

</mat-form-field>

